import type { ConcreteGameRuleConstructor, GameRuleState } from "./GameRule";
import { GameRule } from "./GameRule";
import type {
  SpearheadGameRuleState} from "./SpearheadGameRule";
import {
  SpearheadGameRule,
  SpearheadTerrainFeatureId,
  SpearheadTerrainFeatures,
  SpearheadTerrainFeatureSetId,
  SpearheadTerrainFeatureSets
} from "./SpearheadGameRule";

export * from "./Ability";
export * from "./GameRule";
export * from "./SpearheadGameRule";
export * from "./TerrainFeature";

export type TerrainFeatureId = SpearheadTerrainFeatureId;
export const TerrainFeatureId = SpearheadTerrainFeatureId;

export const TerrainFeatures = SpearheadTerrainFeatures;

export type TerrainFeaturesSetId = SpearheadTerrainFeatureSetId;
export const TerrainFeaturesSetId = SpearheadTerrainFeatureSetId;

export const TerrainFeatureSets = SpearheadTerrainFeatureSets;

export const GameRules = {
  aos4sh:   SpearheadGameRule(GameRule<false, SpearheadGameRuleState>) as unknown as ConcreteGameRuleConstructor<true>,
  d_aos4sh: SpearheadGameRule(GameRule<false, SpearheadGameRuleState>) as unknown as ConcreteGameRuleConstructor<true>
} satisfies { [key: string]: ConcreteGameRuleConstructor<true> };

export type GameRuleId = keyof typeof GameRules;
export const GameRuleId = Object.keys(GameRules) as GameRuleId[];

export type GameRules<S extends boolean> = { [key in GameRuleId]: ConcreteGameRuleConstructor<S> };

export const stateToGameRule = <S extends boolean>(
  id: GameRuleId,
  state: GameRuleState,
  gameRules: GameRules<S>,
  player1Id: number,
  player2Id: number
): GameRule<S> => new gameRules[id](player1Id, player2Id, state);
